import { componentQrl, inlinedQrl, useComputedQrl, useLexicalScope, useStore, useTaskQrl, _jsxS, _jsxC, _IMMUTABLE, _fnSignal } from "@builder.io/qwik";
import { ContentVariants } from "../../components/content-variants/content-variants.qwik.mjs";
import { getClassPropName } from "../../functions/get-class-prop-name.qwik.mjs";
import { fetchSymbolContent } from "./symbol.helpers.qwik.mjs";
const setContent = function setContent2(props, state, blocksWrapper, contentWrapper, className) {
  var _a;
  if (state.contentToUse && state.symbolEntry === ((_a = props.symbol) == null ? void 0 : _a.entry))
    return;
  fetchSymbolContent({
    symbol: props.symbol,
    builderContextValue: props.builderContext
  }).then((newContent) => {
    var _a2;
    if (newContent) {
      state.contentToUse = newContent;
      state.symbolEntry = (_a2 = props.symbol) == null ? void 0 : _a2.entry;
    }
  });
};
const Symbol$1 = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  var _a, _b;
  const blocksWrapper = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    return "div";
  }, "Symbol_component_blocksWrapper_useComputed_B5dlF985gMM"));
  const contentWrapper = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    return "div";
  }, "Symbol_component_contentWrapper_useComputed_EvmPpPj8JTo"));
  const className = useComputedQrl(/* @__PURE__ */ inlinedQrl(() => {
    var _a2, _b2;
    const [props2] = useLexicalScope();
    return [
      props2.attributes[getClassPropName()],
      "builder-symbol",
      ((_a2 = props2.symbol) == null ? void 0 : _a2.inline) ? "builder-inline-symbol" : void 0,
      ((_b2 = props2.symbol) == null ? void 0 : _b2.dynamic) || props2.dynamic ? "builder-dynamic-symbol" : void 0
    ].filter(Boolean).join(" ");
  }, "Symbol_component_className_useComputed_Wb6GqgtDHpE", [
    props
  ]));
  const state = useStore({
    contentToUse: (_a = props.symbol) == null ? void 0 : _a.content,
    symbolEntry: (_b = props.symbol) == null ? void 0 : _b.entry
  });
  useTaskQrl(/* @__PURE__ */ inlinedQrl(({ track }) => {
    const [blocksWrapper2, className2, contentWrapper2, props2, state2] = useLexicalScope();
    track(() => props2.symbol);
    setContent(props2, state2);
  }, "Symbol_component_useTask_NIAWAC1bMBo", [
    blocksWrapper,
    className,
    contentWrapper,
    props,
    state
  ]));
  return /* @__PURE__ */ _jsxS("div", {
    ...props.attributes,
    children: /* @__PURE__ */ _jsxC(ContentVariants, {
      get nonce() {
        return props.builderContext.nonce;
      },
      isNestedRender: true,
      get apiVersion() {
        return props.builderContext.apiVersion;
      },
      get apiKey() {
        return props.builderContext.apiKey;
      },
      get context() {
        var _a2;
        return {
          ...props.builderContext.context,
          symbolId: (_a2 = props.builderBlock) == null ? void 0 : _a2.id
        };
      },
      get customComponents() {
        return Object.values(props.builderComponents);
      },
      get data() {
        var _a2, _b2, _c;
        return {
          ...(_a2 = props.symbol) == null ? void 0 : _a2.data,
          ...props.builderContext.localState,
          ...(_c = (_b2 = state.contentToUse) == null ? void 0 : _b2.data) == null ? void 0 : _c.state
        };
      },
      get canTrack() {
        return props.builderContext.canTrack;
      },
      get model() {
        var _a2;
        return ((_a2 = props.symbol) == null ? void 0 : _a2.model) ?? "";
      },
      get content() {
        return state.contentToUse;
      },
      get linkComponent() {
        return props.builderLinkComponent;
      },
      get blocksWrapper() {
        return blocksWrapper.value;
      },
      get contentWrapper() {
        return contentWrapper.value;
      },
      [_IMMUTABLE]: {
        apiKey: _fnSignal((p0) => p0.builderContext.apiKey, [
          props
        ], "p0.builderContext.apiKey"),
        apiVersion: _fnSignal((p0) => p0.builderContext.apiVersion, [
          props
        ], "p0.builderContext.apiVersion"),
        blocksWrapper: _fnSignal((p0) => p0.value, [
          blocksWrapper
        ], "p0.value"),
        canTrack: _fnSignal((p0) => p0.builderContext.canTrack, [
          props
        ], "p0.builderContext.canTrack"),
        content: _fnSignal((p0) => p0.contentToUse, [
          state
        ], "p0.contentToUse"),
        contentWrapper: _fnSignal((p0) => p0.value, [
          contentWrapper
        ], "p0.value"),
        context: _fnSignal((p0) => {
          var _a2;
          return {
            ...p0.builderContext.context,
            symbolId: (_a2 = p0.builderBlock) == null ? void 0 : _a2.id
          };
        }, [
          props
        ], "{...p0.builderContext.context,symbolId:p0.builderBlock?.id}"),
        customComponents: _fnSignal((p0) => Object.values(p0.builderComponents), [
          props
        ], "Object.values(p0.builderComponents)"),
        data: _fnSignal((p0, p1) => {
          var _a2, _b2, _c;
          return {
            ...(_a2 = p0.symbol) == null ? void 0 : _a2.data,
            ...p0.builderContext.localState,
            ...(_c = (_b2 = p1.contentToUse) == null ? void 0 : _b2.data) == null ? void 0 : _c.state
          };
        }, [
          props,
          state
        ], "{...p0.symbol?.data,...p0.builderContext.localState,...p1.contentToUse?.data?.state}"),
        isNestedRender: _IMMUTABLE,
        linkComponent: _fnSignal((p0) => p0.builderLinkComponent, [
          props
        ], "p0.builderLinkComponent"),
        model: _fnSignal((p0) => {
          var _a2;
          return ((_a2 = p0.symbol) == null ? void 0 : _a2.model) ?? "";
        }, [
          props
        ], 'p0.symbol?.model??""'),
        nonce: _fnSignal((p0) => p0.builderContext.nonce, [
          props
        ], "p0.builderContext.nonce")
      }
    }, 3, "Wt_0")
  }, {
    class: _fnSignal((p0) => p0.value, [
      className
    ], "p0.value")
  }, 0, "Wt_1");
}, "Symbol_component_WVvggdkUPdk"));
export {
  Symbol$1 as Symbol,
  Symbol$1 as default,
  setContent
};
